export type ThemePreference = 'system' | 'light' | 'dark';
export type Theme = 'light' | 'dark';

export function resolveTheme(pref: ThemePreference, systemPrefersDark: boolean): Theme {
  if (pref === 'system') return systemPrefersDark ? 'dark' : 'light';
  return pref;
}
